import {AnsweredObject, MasterSummaryQuestionModel, NonAnsweredObject} from '../../models/survey/survey.model';
import {SurveyVersionModelCore, SurveyCutModelCore} from '../../models/summary/summary.model';
import { AVERAGE_CHART, BAR_CHART, MOST_COMMON_CHART, PIE_CHART, RESPONSE_CLOUD, RESPONSE_COUNT, WORD_CLOUD, WORD_COUNT } from '../constants/input.constants';
import Utils from '../util/Util';

const ANSWER_TYPE_ALLOW_SHOW_BAR_CHART = ['SingleChoice', 'MultipleChoice', 'PictureChoice', 'Dropwdown', 'YesNo',
  'Rating', 'Date', 'Number', 'Text', 'QuestionBundle'];

const ANSWER_TYPE_ALLOW_SHOW_PIE_CHART = ['SingleChoice', 'PictureChoice', 'Dropwdown', 'YesNo',
  'Rating', 'Text', 'Date'];

const ANSWER_TYPE_ALLOW_SHOW_WORD_CLOUD = [ 'Text'];

const ANSWER_TYPE_SHOW_BAR_CHART_FIRST_OPTION = ['SingleChoice', 'MultipleChoice', 'PictureChoice', 'Dropwdown'];

const ANSWER_TYPE_SHOW_PIE_CHART_FIRST_OPTION = ['YesNo', 'Text', 'Date'];

const ANSWER_TYPE_SHOW_AVG_NUMERIC_FIRST_OPTION = ['OpinionScale', 'Rating', 'Number'];

const CHOICE_ANSWER_TYPE = ['SingleChoice', 'MultipleChoice', 'PictureChoice', 'Dropwdown', 'YesNo'];

const ANSWER_TYPE_SHOW_AVERAGE_NUMERIC_RESPONSE = ['OpinionScale', 'Rating', 'Number'];
const ANSWER_TYPE_SHOW_MOST_COMMON = ['SingleChoice', 'MultipleChoice', 'PictureChoice', 'Dropwdown', 'YesNo', 'Rating', 'Number'];
const ANSWER_TYPE_CAN_FILTER_BY_COMBINED = ['SingleChoice', 'MultipleChoice', 'PictureChoice', 'Dropwdown', 'YesNo'];

export let ROSE_CHART_COLORS = ['#6C8EB5','#A0D0C4','#D2F5E3','#A6CF98','#E2BCB7','#F3A173','#F0BE46','#FDE84D'];
export let CHART_COLORS = ['#5278A2','#6C8EB5','#61A4BC','#A0D0C4','#D2F5E3','#A6CF98','#E2BCB7','#F3A173','#F0BE46','#FDE84D'];
export let PARALLEL_CHART_COLORS = ['#6C8EB5', '#A0D0C4', '#D2F5E3', '#A6CF98', '#E2BCB7', '#F3A173', '#F0BE46', '#FDE84D'];

export function allowShowBarchart(type: string): boolean {
  return ANSWER_TYPE_ALLOW_SHOW_BAR_CHART.indexOf(type) !== -1;
}

export function allowShowPieChart(type: string): boolean {
  return ANSWER_TYPE_ALLOW_SHOW_PIE_CHART.indexOf(type) !== -1;
}


export function allowShowWordCloud(type: string): boolean {
  return ANSWER_TYPE_ALLOW_SHOW_WORD_CLOUD.indexOf(type) !== -1;
}

export function showBarChartFirstOption(type: string): boolean {
  return ANSWER_TYPE_SHOW_BAR_CHART_FIRST_OPTION.indexOf(type) !== -1;
}

export function showPieChartFirstOption(type: string): boolean {
  return ANSWER_TYPE_SHOW_PIE_CHART_FIRST_OPTION.indexOf(type) !== -1;
}

export function showAvgNumericFirstOption(type: string): boolean {
  return ANSWER_TYPE_SHOW_AVG_NUMERIC_FIRST_OPTION.indexOf(type) !== -1;
}

export function isChoiceQuestion(answerType: string) {
  return CHOICE_ANSWER_TYPE.indexOf(answerType) !== -1;
}

export function isMultipleOrSingleChoiceQuestion(answerType: string) {
  return 'MultipleChoice' === answerType || 'SingleChoice' === answerType;
}

export function showAverageNumericResponse(type: string): boolean {
  return ANSWER_TYPE_SHOW_AVERAGE_NUMERIC_RESPONSE.indexOf(type) !== -1;
}

export function showMostCommonResponse(type: string): boolean {
  return ANSWER_TYPE_SHOW_MOST_COMMON.indexOf(type) !== -1;
}

export function canFilterByCombined(type: string) {
  return ANSWER_TYPE_CAN_FILTER_BY_COMBINED.indexOf(type) !== -1;
}

export function generateNizPitanja(question: MasterSummaryQuestionModel): any[] {
  const answeredObject = new AnsweredObject();
  answeredObject.answeredCount = question.answeredCount;
  answeredObject.haveAnswered = 'Have answered';
  answeredObject.answerName = 'Have answered';
  answeredObject.answerPercentage = question.answeredPercentage;
  if (question.nizPitanja && question.nizPitanja.length > 0) {
    answeredObject.answerDiffPercShow = question.nizPitanja[0].answerDiffPercShow;
    answeredObject.answerDiffPercentage = question.nizPitanja[0].answerDiffPercentage;
  } else {
    answeredObject.answerDiffPercShow = false;
    answeredObject.answerDiffPercentage = null;
  }

  const nonAnsweredObject = new NonAnsweredObject();
  nonAnsweredObject.answeredCount = question.nonAnsweredCount;
  nonAnsweredObject.haveAnswered = 'Have not answered';
  nonAnsweredObject.answerName = 'Have not answered';
  nonAnsweredObject.answerPercentage = question.nonAnsweredPercentage;
  if (question.nizPitanja && question.nizPitanja.length > 0) {
    nonAnsweredObject.answerDiffPercShow = question.nizPitanja[1].answerDiffPercShow;
    nonAnsweredObject.answerDiffPercentage = question.nizPitanja[1].answerDiffPercentage;
  } else {
    nonAnsweredObject.answerDiffPercShow = false;
    nonAnsweredObject.answerDiffPercentage = null;
  }
  return [answeredObject, nonAnsweredObject];
}

export function setDefaultChart(chart: string, item: MasterSummaryQuestionModel) {
  switch (chart) {
      case BAR_CHART:
          item.barChart = true;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case PIE_CHART:
          item.barChart = false;
          item.chart = true;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case AVERAGE_CHART:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = true;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case MOST_COMMON_CHART:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = true;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case WORD_CLOUD:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = true;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case WORD_COUNT:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = true;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
          break;
      case RESPONSE_CLOUD:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = true;
          item.responseCountResponse = false;
          break;
      case RESPONSE_COUNT:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = false;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = true;
          break;

      default:
          item.barChart = false;
          item.chart = false;
          item.averageResponse = false;
          item.tableData = true;
          item.mostCommonResponse = false;
          item.wordCloudResponse = false;
          item.wordCountResponse = false;
          item.responseCloudResponse = false;
          item.responseCountResponse = false;
  }
}

export function generateIncludeVersionLabel(compare: boolean, listSurveyVersion: SurveyVersionModelCore[]): string {
  return generateIncludeVersionCutLabel(compare, false, listSurveyVersion, []);
}

export function generateIncludeVersionCutLabel(compare: boolean, allResSelectorChecked: boolean,
  listSurveyVersion: SurveyVersionModelCore[], listCutVersion: SurveyCutModelCore[]): string {
  const countVersion = listSurveyVersion ? listSurveyVersion.length : 0;
  const countCut = listCutVersion ? listCutVersion.length : 0;
  if (compare) {
    let count = countVersion + countCut + (allResSelectorChecked ? 1 : 0);
    return count >= 2 ? 'Compare (' + count + ')' : "ALL RESPONSES";
  } else {
    if (countVersion > 1) {
      return 'Combined (' + countVersion + ')';
    } else if (listSurveyVersion && listSurveyVersion.length > 0) {
      return listSurveyVersion[0].surveyName;
    }
  }
}

export function isMaster(surveyName: string): boolean
{
    if (surveyName != null)
    {
        var formatSurveyName = surveyName.trim();

        var start = formatSurveyName.lastIndexOf('(');
        var end = formatSurveyName.lastIndexOf(')');

        if (start >= 0 && start < end && end == formatSurveyName.length - 1)
        {
            var shortName = formatSurveyName.substring(start + 1, end);
            return shortName == "MASTER";
        }
    }
    return false;
}

export function getCanvasIdForAllCharts(questionId: number): string {
  return `allChartsCanvas${questionId}`;
}

export function calculateAbsolute(masterPercentage: number, siblingPercentage: number): number {
  let diffPercentage = siblingPercentage - masterPercentage;
  return Utils.roundNumber(diffPercentage, 1);
}

export function calculateRelative(masterPercentage: number, siblingPercentage: number): number {
  let numerator = siblingPercentage - masterPercentage;
  if(masterPercentage !== 0){
    let diffPercentage = (numerator / masterPercentage) * 100;
    return Utils.roundNumber(diffPercentage, 1);
  }
  return null;
}

export function getDateFormat(dateString: string): string {
  const date = new Date(dateString);

  const mm = date.getMonth() + 1; // getMonth() is zero-based
  const dd = date.getDate();

  return [
    (dd > 9 ? '' : '0') + dd,
    (mm > 9 ? '' : '0') + mm,
    date.getFullYear()
  ].join('/');
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/chart-helper.ts